import useEmojis from '../hooks/use-emojis';
import SymbolBlock from '../symbol-block';
import Emoji from './emoji';

export default function EmojiBlocks() {
  const { emojis } = useEmojis();

  return emojis.map(({ name, slug, symbols }) => (
    <SymbolBlock
      key={slug}
      name={name}
      slug={slug}>
      <div className='grid grid-cols-8'>
        {symbols.map((props) => (
          <Emoji
            key={props.slug}
            {...props}
          />
        ))}
      </div>
    </SymbolBlock>
  ));
}
